export default "__VITE_ASSET__cXfhJFJx__"